import React from 'react';
import './UserList.css';

export default function UserList({ users, selectedUser, onSelectUser }) {
  return (
    <div className="user-list">
      {users.map((user) => (
        <div
          key={user.id}
          className={`user-item ${selectedUser?.id === user.id ? 'active' : ''}`}
          onClick={() => onSelectUser(user)}
        >
          <div className="user-avatar">
            {user.avatar ? (
              <img src={user.avatar} alt={user.username} />
            ) : (
              <div className="avatar-placeholder">{user.username[0].toUpperCase()}</div>
            )}
          </div>
          <div className="user-info">
            <div className="user-name">{user.username}</div>
            <div className="user-email">{user.email}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
